const plpStateComputedMixin = {
  computed: {
    productsList() {
      return this.$store.state.productsListPage.elementsList;
    },
    selectableVariations(){
      return this.$store.state.productsListPage.selectableVariations;
    },
    sorting() {
      return this.$store.state.productsListPage.sorting;
    },
    navigation() {
      return this.$store.state.productsListPage.navigation;
    },
    pagination() {
      return this.$store.state.productsListPage.pagination;
    },
    filters() {
      return this.$store.state.productsListPage.filters;
    },
    pageType() {
      return this.$store.state.productsListPage.pageType;
    },
    pageSize() {
      return this.$store.state.productsListPage.pageSize;
    },
    activeFilters() {
      return this.$store.getters['productsListPage/activeFilters'];
    }
  }
};

export default plpStateComputedMixin;
